<style lang="less">
.login {
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
  display: flex;
  align-items: center;
  justify-content: center;
  .logCenter {
    width: 450px;
    .title {
      width: 100%;
      text-align: center;
      color: #fff;
      font-weight: 800;
      font-size: 30px;
      margin-bottom: 40px;
    }
    .inputOut {
      width: 100%;
      height: 49px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0px 20px 0px 10px;
      background-color: rgba(0, 0, 0, 0.3);
      margin-bottom: 22px;
      border-radius: 6px;
      .figure {
        width: 20px;
        height: 20px;
      }
      .input {
        width: 380px;
        color: #111;
        height: 47px;
        box-sizing: border-box;
        padding: 12px 5px 12px 15px;
      }
    }
    .loginButton {
      width: 100%;
      height: 48px;
    }
    .call {
      margin-top: 10px;
      width: 100%;
      height: 48px;
      border-radius: 6px;
      text-align: center;
      line-height: 48px;
      background: #fff;
    }
  }
}
</style>
<template>
  <div class="login">
    <div class="logCenter">
      <div class="title">机构后台管理系统</div>
      <div class="inputOut">
        <img
          :src="userImg"
          class="figure"
        >
        <input
          type="text"
          placeholder="请输入用户名"
          class="input"
          v-model="username"
        >
      </div>
      <div class="inputOut">
        <img
          :src="passwdImg"
          class="figure"
        >
        <input
          type="password"
          placeholder="请输入密码"
          class="input"
          v-model="password"
        >
      </div>
      <i-button
        type="primary"
        class="loginButton"
        @click="Login"
      >登录</i-button>
      <div class="call">
        还没有开通机构？
        <a href="https://wap.qupeiyin.cn/addOrgan/questionPage/from/0?from_id=53">联系我们</a>
        <!-- https://www.wjx.top/jq/43253208.aspx -->
      </div>
    </div>
  </div>
</template>

<script>
import userImg from '@assets/figure.png'
// import store from '@src/store'
import passwdImg from '@assets/password.png'
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      userImg: userImg,
      passwdImg: passwdImg
    }
  },
  created() {
    this.$Message.config({
      top: 50,
      duration: 3
    })
  },
  methods: {
    Login() {
      if (this.username == '' || this.password == '') {
        this.$Message.warning('账号密码不能为空')
      } else {
        this.$store
          .dispatch('login', {
            username: this.username,
            password: this.password
          })
          .then(result => {
            if (result.success == true) {
              this.$router.push({
                name: 'home',
                query: { t: new Date().getTime() }
              })
            } else {
              this.$Message.error(result.message)
            }
          })
      }
    }
  }
}
</script>

